import { useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import TextSearch from '../../controls/TextSearch';
import { useDebounce } from '@uidotdev/usehooks';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';

type DataGridSearchProps = {
  searchTerm: string;
  placeholder: string;
  onSearchChange: (val: string) => void;
};

const DataGridSearch = ({
  searchTerm,
  placeholder,
  onSearchChange,
}: DataGridSearchProps) => {
  const t = useCommonTranslation();
  const [value, setValue] = useState(searchTerm);
  const debouncedSearchTerm = useDebounce(value, 250);

  const handleSearchChange = (val: string) => {
    setValue(val);
  };

  useEffect(() => {
    onSearchChange(debouncedSearchTerm || '');
  }, [debouncedSearchTerm, onSearchChange]);

  return (
    <TextSearch
      id="text-search"
      icon={<SearchIcon />}
      label={t('common.search')}
      placeholder={placeholder}
      currentSearchFilter={value}
      onSearchChange={handleSearchChange}
    />
  );
};

export { DataGridSearch };
export type { DataGridSearchProps };
